import { Card, CardContent } from '@/components/ui/card'
import { formatSEK } from '@/lib/formatters'
import { Users, Banknote, Mail, Receipt } from 'lucide-react'
import type { ExportTotals, EmailStats } from '@/hooks/useExportController'

interface ExportSummaryHeaderProps {
  totals: ExportTotals
  emailStats: EmailStats
}

/**
 * Summary cards showing period totals and email statistics
 */
export function ExportSummaryHeader({ totals, emailStats }: ExportSummaryHeaderProps) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {/* Total bruttolön */}
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center gap-3">
            <div className="rounded-lg bg-blue-100 p-2">
              <Banknote className="h-5 w-5 text-blue-600" />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Bruttolön</p>
              <p className="text-xl font-semibold">{formatSEK(totals.totalGrossSalary)}</p>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Att utbetala */}
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center gap-3">
            <div className="rounded-lg bg-green-100 p-2">
              <Receipt className="h-5 w-5 text-green-600" />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Att utbetala</p>
              <p className="text-xl font-semibold">{formatSEK(totals.totalPayout)}</p>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Antal förare */}
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center gap-3">
            <div className="rounded-lg bg-purple-100 p-2">
              <Users className="h-5 w-5 text-purple-600" />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Antal förare</p>
              <p className="text-xl font-semibold">{totals.driverCount}</p>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Email skickade */}
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center gap-3">
            <div className="rounded-lg bg-orange-100 p-2">
              <Mail className="h-5 w-5 text-orange-600" />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Email skickade</p>
              <p className="text-xl font-semibold">
                {emailStats.alreadySent} / {emailStats.withEmail}
              </p>
              {emailStats.withoutEmail > 0 && (
                <p className="text-xs text-muted-foreground">
                  {emailStats.withoutEmail} saknar email
                </p>
              )}
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
